import theme from "../slices/themeSlice";
import typography from "../slices/typographySlice";
import appState from "../slices/appStateSlice";
import orgSettings from "../slices/orgSettingsSlice";
import userInfo from "../slices/userInfoSlice";
import translation from "@redux/slices/translationSlice";
import navMenu from "@redux/slices/navMenuSlice";
import { combineReducers } from "@reduxjs/toolkit";
import selectedGroups from "../slices/searchGroupsSlice";
import searchFilters from "../slices/searchFilters";
import onboardingData from "@redux/slices/OnboardingDataSlice";
import navigationMenu from "@redux/slices/navigationMenuSlice";
import navigationHistory from "@redux/slices/navigationHistorySlice";

import pdpLayout from "../slices/pdpLayoutSlice";
import menuConfiguration from "@redux/slices/menuConfigurationSlice";
import globalData from "@redux/slices/globalSlice";
import customSearchData from "@redux/slices/searchResultsCustomization";
import otherGroups from "../slices/otherSearchGroups";
import AsyncStorage from "@react-native-async-storage/async-storage";
import bulkRequestSlice from "@redux/slices/bulkRequestSlice";
import { persistReducer } from "redux-persist";
import unifiedProductPages from "@redux/slices/unifiedProductPages";
import orderCartSlice from "@redux/slices/orderCartSlice";
import { Platform } from "react-native";
import adBatch from "@redux/slices/adBatchSlice";

// Create a safe session storage that handles missing sessionStorage gracefully
const getSessionStorage = () => {
  if (Platform.OS !== "web") return AsyncStorage;

  try {
    if (typeof window !== "undefined" && window.sessionStorage) {
      return require("redux-persist/lib/storage/session").default;
    }
  } catch (e) {
    // sessionStorage not available
  }

  // Fallback to no-op storage
  return {
    getItem: () => Promise.resolve(null),
    setItem: () => Promise.resolve(),
    removeItem: () => Promise.resolve(),
  };
};

const appStateConfig = {
  key: "appState",
  storage: AsyncStorage,
  blacklist: ["loginModalType", "navigationHeight"],
};

const userInfoConfig = {
  key: "userInfo",
  storage: AsyncStorage,
};

const translationConfig = {
  key: "translation",
  storage: AsyncStorage,
};

const searchFiltersConfig = {
  key: "searchFilters",
  storage: getSessionStorage(),
};

const navigationHistoryConfig = {
  key: "navigationHistory",
  storage: getSessionStorage(),
};

const adBatchConfig = {
  key: "adBatch",
  storage: AsyncStorage,
};

const searchFiltersReducer =
  Platform.OS === "web"
    ? persistReducer(searchFiltersConfig, searchFilters)
    : searchFilters;

const navigationHistoryReducer =
  Platform.OS === "web"
    ? persistReducer(navigationHistoryConfig, navigationHistory)
    : navigationHistory;

export default combineReducers({
  theme,
  typography,
  appState: persistReducer(appStateConfig, appState),
  orgSettings,
  userInfo: persistReducer(userInfoConfig, userInfo),
  translation: persistReducer(translationConfig, translation),
  selectedGroups,
  navMenu,
  searchFilters: searchFiltersReducer,
  onboardingData,
  navigationMenu,
  menuConfiguration,
  globalData,
  customSearchData,
  pdpLayout,
  otherGroups,
  bulkRequestSlice,
  orderCartSlice,
  unifiedProductPages,
  navigationHistory: navigationHistoryReducer,
  adBatch: persistReducer(adBatchConfig, adBatch),
});
